// 26 ADM-095 point 2 and 10 SIM-297: each of the twelve thoughts, with the share of the strokes of its
// family on which the perfect player takes it, beside the line sim.gate.thought_min_share. A thought
// under the line is marked. Shown in the approval queue (the impact note's option-worth pass) and on
// the screen "Simulation" (the judgement proof's run). Display only: the server decides (ADM-004).
import { adminText } from '../lib/copy';
import { pct, THOUGHTS, thoughtName } from '../lib/fairplay';

export function ThoughtTable({
  shares,
  line,
  caption,
}: {
  shares: Readonly<Record<string, unknown>>;
  line: number;
  caption: string;
}) {
  return (
    <div className="scroll">
      <table className="compact">
        <caption>{caption}</caption>
        <thead>
          <tr>
            <th scope="col">Thought</th>
            <th scope="col">Best pick on</th>
            <th scope="col">Result</th>
          </tr>
        </thead>
        <tbody>
          {THOUGHTS.map((t) => {
            const s = shares[t];
            const under = typeof s !== 'number' || s < line;
            return (
              <tr key={t} className={under ? 'under' : undefined}>
                <th scope="row">{thoughtName(t)}</th>
                <td>{typeof s === 'number' ? pct(s) : '—'}</td>
                <td>
                  <span className={under ? 'chip bad' : 'chip ok'}>
                    {under ? adminText('thoughts.under') : adminText('thoughts.over')}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
